import formieInstance from '../globals/formie';


class Form {
  constructor($el) {
    this.$el = $el;
    this.form = this.$el[0];
    this.FormieInstance = null;
    this.init();
  }

  init() {
    // Initialise a form from its DOM element
    formieInstance.initForm(this.form);
  }

  destroy() {
    formieInstance.destroyForm(this.form);
    $('#FORMIE_RECAPTCHA_SCRIPT').remove();
  }

}

export default Form;
